import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  min-height: calc(100vh - 50px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
  justify-content: space-between;
  background-color: #363636;
  font-family: Montserrat-Medium;
  fill: #fff;

  input,
  textarea {
    font-size: 16px;
  }

  h1 {
    color: #fff;
    text-align: left;
    width: 90%;
    font-size: 18px;
    margin-bottom: 10px;
  }

  p {
    color: #fff;
    text-align: left;
    width: 92%;
    font-size: 14px;
  }
`;

export const ViewMax = styled.div`
  width: 100%;
  max-width: 500px;
  position: relative;
  display: flex;
  flex: 1;
  padding: 25px 0;
  flex-direction: column;
  align-items: center;
`;

export const Logo = styled.img`
  width: 90px;
  margin: 50px 0;
`;

export const ViewRow = styled.div`
  width: 95%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonBack = styled.button`
  height: 40px;
  border-radius: 40px;
  width: 40px;
  display: flex;
  padding: 0 0 0 1px;
  background-color: #fff;
  justify-content: center;
  align-items: center;
`;

export const ViewStats = styled.div`
  width: 90%;
  display: flex;
  justify-content: space-around;
  background-color: #282828;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;

  div {
    text-align: center;
    p {
      text-align: center;
      width: 100%;
      margin: 0;
    }
    span {
      color: #fff;
      font-size: 20px;
      font-weight: bold;
    }
  }
`;

export const ViewNotificationItem = styled.div`
  width: 90%;
  background-color: #282828;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;

  h3 {
    color: #fff;
    margin-bottom: 5px;
    font-size: 16px;
  }

  p {
    color: #ccc;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .status {
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: bold;
    &.aprovado {
      background-color: #20d072;
      color: #fff;
    }
    &.pendente {
      background-color: #f1c40f;
      color: #000;
    }
    &.reprovado {
      background-color: #e74c3c;
      color: #fff;
    }
  }

  .date {
    width: 100%;
    color: #fff;
    font-size: 12px;
    font-family: Montserrat-Regular;
    opacity: 0.7;
  }
`;
